import { Injectable } from '@angular/core';

declare var Messenger: any;

@Injectable({
	providedIn: 'root',
})
export class MessengerService {
	message(message, type: MessengerType, id?: string) {
		return Messenger().post({
			message,
			type,
			showCloseButton: true,
			hideAfter: 5,
			id: id ? id : null,
			singleton: !!id,
		});
	}
}
